var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKindWord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.015 31.256l-6.854 7.122c-1.715 1.782-4.503 1.77-6.23-.025l-6.907-7.173c-2.431-2.527-3.031-6.525-1.166-9.497 2.565-4.083 7.963-4.479 11.123-1.194 3.135-3.258 8.539-2.825 11.131 1.282 1.89 2.987 1.318 6.976-1.097 9.485z",
    fill: "#BCC7C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M63 14.501v28a7 7 0 01-7 7H38.5l-17.5 14v-14h-7a7 7 0 01-7-7v-28a7 7 0 017-7h42a7 7 0 017 7z",
    stroke: "#BCC7C8",
    strokeWidth: 5.833,
    strokeLinejoin: "round"
  })));
}
export default SvgKindWord;